<div id="imageModal" class="modal">
  <span class="close" (click)="close($event)">&times;</span>
  <img class="modal-content" [src]="selectedProduct.final_picture_path"/>
  <div class="caption">
  	{{selectedProduct.translatedName}}
  	<div class="caption-description">{{selectedProduct.translatedDescription}}</div>
  </div>
</div>